/**
 * Returns a promise that resolves after the given number of milliseconds.
 * @param ms - Duration to wait in milliseconds.
 */
export function sleepInMs(ms: number): Promise<void> {
    return new Promise<void>((resolve) => setTimeout(resolve, ms))
}
